import { UsersRoutingModule } from './users/users-routing.module';
import { PageManagerRoutingModule } from './page-manager/page-manager-routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginModule } from './login/login.module';
import { SharedModule } from './shared/shared.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule } from '@angular/common/http';
import { DemoMaterialModule } from './demo-material-module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerModule } from "ngx-spinner";
import { CoreContentManagerRoutingModule } from './core-content-manager/core-content-manager-routing.module';
import { QuillModule } from 'ngx-quill';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { SettingComponent } from './setting/setting.component';
import { ReplaceUnderscorePipe } from './replace-underscore.pipe';

@NgModule({
  declarations: [
    AppComponent,
    SettingComponent,
    ReplaceUnderscorePipe,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    LoginModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    PageManagerRoutingModule,
    CoreContentManagerRoutingModule,
    BsDatepickerModule.forRoot(),
    NgxSpinnerModule,
    QuillModule.forRoot(),
    NgxDropzoneModule,
    DemoMaterialModule,
    UsersRoutingModule

  ], exports: [
    AppComponent,

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
